import { Injectable, inject } from "@angular/core";
import { IMapGeometry, IMapSettings } from "../map.settings";
import { Symbols } from "../symbols/symbol.styles";
import { IMapService } from "./map-select.service";
import { SpatialService } from "./spatial.service";

@Injectable({
    providedIn: "root"
})
export class MapFreehandService implements IMapService {
    isDrawing = false;

    private readonly spatialService = inject(SpatialService);

    private arcDraw: any;
    private arcView: any;
    private events: any[] = [];

    init(mapsettings: IMapSettings, arcView: any, arcDraw: any, arcQueryTask: any) {
        this.arcView = arcView;
        this.arcDraw = arcDraw;
    }

    start(onFinish: (freehandGeometry: IMapGeometry) => void) {
        this.isDrawing = true;
        this.arcView.graphics.removeAll();
        this.arcView.focus();

        const action = this.arcDraw.create("polygon", { mode: "freehand" });
        this.events.push(action.on([
            "vertex-add",
            "cursor-update",
            "vertex-remove"
        ], evt => {
            this.showSelectArea(evt.vertices);
        }));

        this.events.push(action.on("draw-complete", evt => {
            this.showSelectAreaFinal(evt.vertices);
            const arcPolygon = this.spatialService.toPolygon(evt.vertices, null);
            const geom = this.spatialService.simplifyOgc(arcPolygon.geometry);
            arcPolygon.geometry = geom;
            const freehandGeometry = this.spatialService.toRask(arcPolygon, true);
            onFinish(freehandGeometry);
            setTimeout(() => {
                this.arcView.graphics.removeAll();
                this.isDrawing = false;
            }, 200);
        }));
    }

    stop() {
        this.arcDraw.reset();
        this.arcView.graphics?.removeAll();
        this.isDrawing = false;
        this.events?.forEach(e => {
            e.remove();
        });
        this.events = [];
    }

    private showSelectArea(vertices: any) {
        this.arcView.graphics.removeAll();
        this.arcView.graphics.addMany(
            [
                this.spatialService.toPolyline(vertices, Symbols.Styles.lassoline1),
                this.spatialService.toPolyline(vertices, Symbols.Styles.lassoline2)
            ]);
    }

    private showSelectAreaFinal(vertices: any) {
        this.arcView.graphics.removeAll();
        this.arcView.graphics.addMany(
            [
                this.spatialService.toPolygon(vertices, Symbols.Styles.lassofill),
                this.spatialService.toPolyline(vertices, Symbols.Styles.lassoline2)
            ]);
    }
}
